import { render, staticRenderFns } from "./TeamIntegrationsEdit.vue?vue&type=template&id=3c852cb8&scoped=true"
import script from "./TeamIntegrationsEdit.vue?vue&type=script&lang=js"
export * from "./TeamIntegrationsEdit.vue?vue&type=script&lang=js"
import style0 from "./TeamIntegrationsEdit.vue?vue&type=style&index=0&id=3c852cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c852cb8",
  null
  
)

export default component.exports